import React from 'react'
import { useNavigate } from 'react-router-dom';
import outIcon from '../images/outArrow.svg'
import { useAuth } from '../hooks/useAuth';
export default function Header() {
  const navigate = useNavigate()
  const { logout } = useAuth()


  return (
    <div className='header'>
      <h2 className="header__title">Good Day Афиша</h2>
      <nav className="header__content">
        <ul>
          <li className="header__link" onClick={() => navigate('/info', { replace: false })}>Посты</li>
          <li className="header__link" onClick={() => navigate('/posters', { replace: false })}>Афиша</li>
          <li className="header__link" onClick={() => navigate('/categories', { replace: false })}>Категории</li>
          <li className="header__link" onClick={() => navigate('/users', { replace: false })}>Админы</li>
          <li className="header__link" onClick={() => logout()}>
            <img src={outIcon} alt="" />
          </li>
        </ul>
      </nav>
    </div>
  )
}
